import { configureStore } from '@reduxjs/toolkit'
import dashboardReducer from './dashboardSlice'
import settingsReducer from './settingsSlice'
import controlledSubstancesReducer from './controlledSubstancesSlice'
import labOrdersReducer from './labOrdersSlice'
import labWorkReducer from './labWorkSlice'
import medicationsReducer from './medicationsSlice'
import medicationListReducer from './medicationListSlice'
import prescriptionsReducer from './prescriptionsSlice'
import prescriptionListReducer from './prescriptionListSlice'
import treatmentsReducer from './treatmentsSlice'
import treatmentListReducer from './treatmentListSlice'
import patientDetailReducer from './patientDetailSlice'
import patientListReducer from './patientListSlice'

export const store = configureStore({
  reducer: {
    dashboard: dashboardReducer,
    settings: settingsReducer,
    controlledSubstances: controlledSubstancesReducer,
    labOrders: labOrdersReducer,
    labWork: labWorkReducer,
    medications: medicationsReducer,
    medicationList: medicationListReducer,
    prescriptions: prescriptionsReducer,
    prescriptionList: prescriptionListReducer,
    treatments: treatmentsReducer,
    treatmentList: treatmentListReducer,
    patientDetail: patientDetailReducer,
    patientList: patientListReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
